import $ from "jquery";
import "./style.css";

export default class Header {
  static selector = ".header";

  constructor(block) {
    this.block = block;

    // Get search elements
    this.searchButton = this.block.querySelector(".header__search");
    this.searchCloseButton = this.block.querySelector(
      ".header__search-bar-close"
    );
    this.searchInput = this.block.querySelector(".header__search-bar-input");

    this.hamburger = this.block.querySelector(".header__hamburger");
    this.nav = this.block.querySelector(".header__nav");
    this.content = document.querySelector(".article, .publication");
    this.menus = Array.from(
      this.nav.querySelectorAll(".header__menu-item--has-children")
    );

    this.lastScroll = 0;
    this.scrollY = 0;
    this.isSticky = false;
    this.isOpen = false;

    this.hamburger.addEventListener("click", this.onHamburgerClick);
    this.menus.forEach(this.initMenu);

    // Filters elements
    this.filtersWrapper = this.block.querySelector(".header__filters");
    this.filtersToggle = this.block.querySelector(".header__filters-toggle");
    this.filterTopic = this.block.querySelector("select[name='apGridTopic']");
    this.filterDateFrom = this.block.querySelector(
      "input[name='apGridDateFrom']"
    );
    this.filterDateTo = this.block.querySelector("input[name='apGridDateTo']");
    this.filtersReset = this.block.querySelector(
      ".header__filters-actions-button--reset-all"
    );
    this.filtersApply = this.block.querySelector(
      ".header__filters-actions-button--apply"
    );
  }

  closeSubmenu = menuItem => {
    if (!menuItem.classList.contains("header__menu-item--expanded")) {
      return;
    }

    const submenu = menuItem.querySelector(".header__submenu");
    const $submenu = $(submenu);

    // close
    menuItem.classList.remove("header__menu-item--expanded");
    $submenu
      .find("li")
      .css({ opacity: 1 })
      .stop()
      .animate({ opacity: 0 }, 200);
    $submenu.delay(300).animate({ opacity: 0, height: "toggle" }, 200);

    window.removeEventListener("click", this.onWindowClicked);
  };

  openSubmenu = menuItem => {
    if (menuItem.classList.contains("header__menu-item--expanded")) {
      return;
    }

    const submenu = menuItem.querySelector(".header__submenu");
    const $submenu = $(submenu);

    // open
    menuItem.classList.add("header__menu-item--expanded");
    $submenu.animate({ opacity: 1, height: "toggle" }, 300);
    $submenu
      .find("li")
      .css({ opacity: 0 })
      .stop()
      .delay(300)
      .animate({ opacity: 1 }, 300);

    this.onWindowClicked = this.getOnWindowClicked(menuItem);

    window.addEventListener("click", this.onWindowClicked);
  };

  getOnWindowClicked = menuItem => {
    return e => {
      let targetElement = e.target;

      const submenu = menuItem.querySelector(".header__submenu");

      do {
        if (targetElement === submenu) {
          return;
        }

        targetElement = targetElement.parentNode;
      } while (targetElement);

      this.close(this.block);
    };
  };

  initMenu = menuItem => {
    const handle = menuItem.querySelector(".header__menu-item-link");
    const submenu = menuItem.querySelector(".header__submenu");
    const $submenu = $(submenu);
    $submenu.hide();

    this.onWindowClicked = () => {};

    const onSubmenuHandleClick = e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (menuItem.classList.contains("header__menu-item--expanded")) {
        this.closeSubmenu(menuItem);
      } else {
        this.closeSubmenus();
        this.openSubmenu(menuItem);
      }
    };

    handle.addEventListener("click", onSubmenuHandleClick);
  };

  closeSubmenus() {
    this.menus.forEach(this.closeSubmenu);
  }
  clearStickyTimeout() {
    if (this.stickyTimeout) {
      this.stickyTimeout = clearTimeout(this.stickyTimeout);
      this.block.classList.remove("header--sticky");
      this.block.classList.remove("header--sticky-hidden");
    }
  }
  checkForScrollDirection = y => {
    const scrollUp = "scroll-up";
    const scrollDown = "scroll-down";
    const { body } = document;

    if (y <= 0) {
      body.classList.remove(scrollUp);
      return;
    }

    if (y > this.lastScroll && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.add(scrollDown);
    } else if (y < this.lastScroll && body.classList.contains(scrollDown)) {
      // up
      body.classList.remove(scrollDown);
      body.classList.add(scrollUp);
    }

    this.lastScroll = y;
  };

  checkForStickyness() {
    const scrollY = window.scrollY;
    let isSticky = false;
    let isTop = false;

    if (!scrollY) {
      isSticky = false;
      isTop = true;
    } else if (scrollY <= this.block.offsetHeight) {
      isSticky = false;
    } else if (scrollY < this.scrollY) {
      isSticky = true;
    } else {
      isSticky = false;
    }

    this.closeSubmenus();

    if (isSticky && !this.isSticky) {
      this.clearStickyTimeout();
      this.block.classList.add("header--sticky");
    } else if (!isSticky && this.isSticky) {
      this.clearStickyTimeout();

      if (!isTop) {
        this.block.classList.add("header--sticky-hidden");

        this.stickyTimeout = setTimeout(() => {
          this.block.classList.remove("header--sticky");
          this.block.classList.remove("header--sticky-hidden");
        }, 500);
      } else {
        this.block.classList.remove("header--sticky");
      }
    }

    this.scrollY = scrollY;
    this.isSticky = isSticky;
  }

  open() {
    this.block.classList.add("header--open");
    document.body.classList.add("no-scroll");
  }
  close() {
    this.closeSubmenus();
    this.block.classList.remove("header--open");
    document.body.classList.remove("no-scroll");
  }

  // Event handlers
  onSearchInputKeyUp = e => {
    if (!window.App.theSearchBox) {
      return;
    }

    const query = e.currentTarget.value;

    if (query.length < 3) {
      window.App.theSearchBox.close();
      return;
    }

    window.App.theSearchBox.search(query);
  };
  onSearchButtonClick = () => {
    this.block.classList.add("header--search-open");
    this.searchInput.addEventListener("keyup", this.onSearchInputKeyUp);
  };
  onSearchCloseButtonClick = () => {
    this.block.classList.remove("header--search-open");

    this.searchInput.removeEventListener("keyup", this.onSearchInputKeyUp);
    this.searchInput.value = "";

    window.App.theSearchBox?.close?.();
  };
  onHamburgerClick = () => {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.open();
    } else {
      this.close();
    }
  };

  onBack = event => {
    history.back();
    event.preventDefault();
  };

  onFiltersToggleClick = () => {
    document.body.classList.toggle("filters-header-open");
  };
  onFiltersReset = () => {
    this.filterTopic.value = "";
    this.filterDateFrom.value = "";
    this.filterDateTo.value = "";
  };
  handleFiltersClose = () => {
    document.body.classList.remove("filters-header-open");
  };

  // Public
  onReady = () => {
    this.searchButton?.addEventListener("click", this.onSearchButtonClick);
    this.searchCloseButton?.addEventListener(
      "click",
      this.onSearchCloseButtonClick
    );

    this.filtersToggle?.addEventListener("click", this.onFiltersToggleClick);
    this.filtersReset?.addEventListener("click", this.onFiltersReset);
    this.filtersApply?.addEventListener("click", this.handleFiltersClose);
  };
  onDestroy = () => {
    this.searchButton?.removeEventListener("click", this.onSearchButtonClick);
    this.searchCloseButton?.removeEventListener(
      "click",
      this.onSearchCloseButtonClick
    );
    this.searchInput?.removeEventListener("keyup", this.onSearchInputKeyUp);

    this.filtersToggle?.removeEventListener("click", this.onFiltersToggleClick);
    this.filtersReset?.removeEventListener("click", this.onFiltersReset);
    this.filtersApply?.removeEventListener("click", this.handleFiltersClose);
  };
  onResize() {
    this.checkForStickyness();
    this.close();
    this.handleFiltersClose();
  }

  onScroll() {
    this.checkForStickyness();

    this.checkForScrollDirection(window.scrollY);
  }
}
